<div class="container sticky-top">
  <div class="d-flex justify-content-center py-2 align-items-center bg-white">
    <img class="nav-logo cursor-pointer" src="../../assets/Amrize_h_rgb.svg" alt="Logo" routerLink="/welcome" style="cursor: pointer" />
    <a class="title" routerLink="/welcome"><b>{{languageService.languageConfig?.application_header}}</b></a>
    @if(isLoggedIn && identityClaims) {
    <div class="dropdown">
      <div class="d-flex align-items-center">
        <h2 class="me-2 mb-0">{{ userProfile?.name }}</h2>

        <div class="d-flex align-items-center dropdown-toggle" id="profileDropdown" role="button"
          data-bs-toggle="dropdown" aria-expanded="false" aria-label="Profile options dropdown" style="cursor: pointer">
          <img [src]="sanitizer.bypassSecurityTrustResourceUrl(userProfile?.picture)" alt="Profile" class="rounded-circle avatar" width="50" height="50"
            style="object-fit: cover" />
        </div>
        <app-language style="margin-left: 20px;"></app-language>
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="profileDropdown">
          <!-- <li>
            <a class="dropdown-item" routerLink="/statistics">Statistics</a>
          </li> -->
          <li><a class="dropdown-item" (click)="onLogout()">{{languageService.languageConfig?.logout}}</a></li>
        </ul>
      </div>
    </div>
    }
    @else {
    <div class="flex-column my-auto">
      <a class="nav-link" (click)="configure()">
        <p style="color:yellow; cursor: pointer;"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="24"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
            <polyline points="10 17 15 12 10 7"></polyline>
            <line x1="15" y1="12" x2="3" y2="12"></line>
          </svg>
          Login
        </p>
      </a>
    </div>
    }

  </div>

  <div class="d-flex justify-content-center">
    <div class="gradient"></div>
  </div>
</div>